import React from 'react';
import styled from '@benzinga/themetron';
import { Product } from '@benzinga/content-manager';

const CompareProductTable = React.lazy(() =>
  import('@benzinga/product-ui').then(module => {
    return { default: module.CompareProductTable };
  }),
);

export interface CompareProductsProps {
  attrs: any;
  products: Product[];
  type: 'default' | 'sidebar';
}

export const CompareProducts: React.FC<CompareProductsProps> = ({ attrs, products, type }) => {
  const isSidebar = type == 'sidebar';
  return (
    <CompareProductsWrapper $isSidebar={isSidebar} className="block compare-products">
      <CompareProductTable
        customFields={attrs?.data?.stacked_custom_fields}
        isOpen={attrs.data.default_open_description === '1'}
        layout={attrs?.data?.style && attrs?.data?.style != '' ? attrs?.data?.style : 'table'}
        products={products}
        sectionHash={attrs?.data?.b_id}
      />
    </CompareProductsWrapper>
  );
};
export const CompareProductsWrapper = styled.div<{ $isSidebar?: boolean }>`
  &.compare-products {
    clear: both;
    margin-bottom: 1rem;

    ${({ $isSidebar }) =>
      $isSidebar &&
      `
      .compare-products-table-container {
          .compare-products-list .list-items {
            flex-direction: column;
            text-align: center;
          }
          .image-container {
            margin-right: unset;
          }
      }

    `}
  }
`;
